module.exports = __webpack_public_path__ + "img/theme14.c52d1cff.png";